export const Localstorage = {
  AccountStore: "account.store",
  AuthStore: "auth.store",
  HomeTabStore: "home-tab.store",
  PreferencesStore: "preferences.store",
  ProStore: "pro.store",
  SearchStore: "search.store",
  Theme: "theme"
};
